import { initContract } from "@ts-rest/core";
import {
    agentSkillChatEditBodySchema,
    agentSkillChatEditResponseSchema,
    agentSkillCreateBodySchema,
    agentSkillFlaggedResponseSchema,
    agentSkillIdPathParamsSchema,
    agentSkillListQuerySchema,
    agentSkillListResponseSchema,
    agentSkillRevisionIdPathParamsSchema,
    agentSkillRevisionListResponseSchema,
    agentSkillSchema,
    agentSkillUpdateBodySchema,
    agentSkillWriteResponseSchema,
} from "@common/schemas/domains/agentSkills/agent-skill.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { OrganizationPathParamsSchema } from "@common/schemas/organization-service.schema";

const c = initContract();

const readErrors = {
    403: ErrorMessageSchema,
    404: ErrorMessageSchema,
};

const writeErrors = {
    ...readErrors,
    400: ErrorMessageSchema,
    409: agentSkillFlaggedResponseSchema,
    503: ErrorMessageSchema,
};

const skillPathParams = OrganizationPathParamsSchema.merge(
    agentSkillIdPathParamsSchema,
);

export const agentSkillContract = c.router(
    {
        listAgentSkills: {
            method: "GET",
            path: "/organizations/:organizationId",
            pathParams: OrganizationPathParamsSchema,
            query: agentSkillListQuerySchema,
            responses: { 200: agentSkillListResponseSchema, ...readErrors },
        },
        createAgentSkill: {
            method: "POST",
            path: "/organizations/:organizationId",
            pathParams: OrganizationPathParamsSchema,
            body: agentSkillCreateBodySchema,
            responses: { 201: agentSkillSchema, ...writeErrors },
        },
        getAgentSkill: {
            method: "GET",
            path: "/organizations/:organizationId/:skillId",
            pathParams: skillPathParams,
            responses: { 200: agentSkillSchema, ...readErrors },
        },
        updateAgentSkill: {
            method: "PATCH",
            path: "/organizations/:organizationId/:skillId",
            pathParams: skillPathParams,
            body: agentSkillUpdateBodySchema,
            responses: { 200: agentSkillWriteResponseSchema, ...writeErrors },
        },
        chatEditAgentSkill: {
            method: "POST",
            path: "/organizations/:organizationId/:skillId/chat-edit",
            pathParams: skillPathParams,
            body: agentSkillChatEditBodySchema,
            responses: {
                200: agentSkillChatEditResponseSchema,
                ...writeErrors,
            },
        },
        enableAgentSkill: {
            method: "POST",
            path: "/organizations/:organizationId/:skillId/enable",
            pathParams: skillPathParams,
            body: c.noBody(),
            responses: { 200: agentSkillSchema, ...writeErrors },
        },
        disableAgentSkill: {
            method: "POST",
            path: "/organizations/:organizationId/:skillId/disable",
            pathParams: skillPathParams,
            body: c.noBody(),
            responses: { 200: agentSkillSchema, ...writeErrors },
        },
        archiveAgentSkill: {
            method: "POST",
            path: "/organizations/:organizationId/:skillId/archive",
            pathParams: skillPathParams,
            body: c.noBody(),
            responses: { 200: agentSkillSchema, ...writeErrors },
        },
        resetAgentSkill: {
            method: "POST",
            path: "/organizations/:organizationId/:skillId/reset",
            pathParams: skillPathParams,
            body: c.noBody(),
            responses: { 200: agentSkillSchema, ...writeErrors },
        },
        listAgentSkillRevisions: {
            method: "GET",
            path: "/organizations/:organizationId/:skillId/revisions",
            pathParams: skillPathParams,
            responses: {
                200: agentSkillRevisionListResponseSchema,
                ...readErrors,
            },
        },
        restoreAgentSkillRevision: {
            method: "POST",
            path: "/organizations/:organizationId/:skillId/revisions/:revisionId/restore",
            pathParams: OrganizationPathParamsSchema.merge(
                agentSkillRevisionIdPathParamsSchema,
            ),
            body: c.noBody(),
            responses: { 200: agentSkillWriteResponseSchema, ...writeErrors },
        },
    },
    { pathPrefix: "/agent-skills" },
);
